"use strict";
exports.__esModule = true;
exports.CHANGE_CREDIT_UTILIZATION = void 0;
exports.CHANGE_CREDIT_UTILIZATION = {
    DEFAULT: {
        PAYMENT_SCHEDULE_ROW_TITLE: '2nd payment amount',
        TITLE: 'Change 2nd payment amount',
        PARAGRAPH: "Your Flex credit line is {{creditLineAmount}}, which is the maximum you can defer to your 2nd payment. Each month, Flex may also adjust your 2nd payment so it doesn\u2019t exceed 50% of your rent bill. The remainder of your total rent will be the amount of your 1st payment.",
        FIRST_PAYMENT_LABEL: '1st payment',
        SECOND_PAYMENT_LABEL: '2nd payment',
        DISCLAIMER: 'Changes will apply to next month’s payments. You can make changes up to 1 day before the end of each month. ',
        CTA: 'Save'
    },
    SLC_CLASSIC: {
        PAYMENT_SCHEDULE_ROW_TITLE: 'Payment split',
        TITLE: 'Change payment split',
        PARAGRAPH: 'You can adjust how your payments are split. Your mid-month payment can be up to {{creditLineAmount}} and can’t be more than half of your rent.',
        FIRST_PAYMENT_LABEL: 'When your rent is due',
        SECOND_PAYMENT_LABEL: 'Later in the month',
        DISCLAIMER: 'Changes will apply to next month’s payments. You can make changes up to 1 day before the end of each month. ',
        CTA: 'Save'
    }
};
